import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { BasicOrganizationUnitsDto, BasicOrganizationUnitsRequestDto, CareerCompetenciesOrganizationUnitService } from '@proxy/organization-units';

@Component({
    selector: 'app-area-selector',
    templateUrl: './area-selector.component.html',
    standalone: false
})
export class AreaSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isSubArea = false;
  @Input() areaIdSelected = '';
  @Input() isDisabled = false;

  @Output() changeSelectedArea = new EventEmitter<BasicOrganizationUnitsDto>();

  areas: BasicOrganizationUnitsDto[];
  selectedArea: BasicOrganizationUnitsDto;
  parentId = '';

  constructor(
    injector: Injector,
    private readonly _organizationUnitService: CareerCompetenciesOrganizationUnitService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadAreas();
  }

  async loadAreas(): Promise<void> {
    try {
      this.showLoading();

      if (this.isSubArea && this.isEmptyString(this.parentId)) {
        return;
      }

      const parentArea: BasicOrganizationUnitsRequestDto = {
        id: !this.isEmptyString(this.parentId) ? this.parentId : undefined
      };

      this.areas = (await firstValueFrom(this._organizationUnitService.getAllBasicAreasByParentArea(parentArea)))?.items;
      this.setSelectedArea();
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedArea.emit(this.selectedArea);
  }

  getLabel(): string {
    return this.isSubArea ? this.l('::SubArea') : this.l('::Area');
  }

  setAreaIfEmpty(areaId: string): void {
    if (this.isEmptyString(this.areaIdSelected)) {
      this.areaIdSelected = areaId;
      this.setSelectedArea();
    }
  }

  private setSelectedArea(): void {
    if (this.areas?.length && !this.isEmptyString(this.areaIdSelected)) {
      this.selectedArea = this.areas.find(x => x.organizationUnitId === this.areaIdSelected);
      this.onSelected();
    }
  }
}
